import { render, staticRenderFns } from "./GastroEnteroscopiaEditComponent.vue?vue&type=template&id=80ba4ee4"
import script from "./GastroEnteroscopiaEditComponent.vue?vue&type=script&lang=js"
export * from "./GastroEnteroscopiaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports